import { sanitizeReturnToPath } from "../../utils/routes";
import {
  DEFAULT_SESSION_TARGET_PATH,
  isKnownBlockingReason,
  isKnownSessionPhase,
  SESSION_BLOCKING_REASONS,
  SESSION_PHASES,
} from "./constants";

const normalizeRequestId = (value) => {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 0) return 0;
  return parsed;
};

export const normalizeSessionTargetPath = (
  candidate,
  fallback = DEFAULT_SESSION_TARGET_PATH
) => sanitizeReturnToPath(candidate, fallback);

export const normalizeBlockingReason = (reason) =>
  isKnownBlockingReason(reason) ? reason : SESSION_BLOCKING_REASONS.unknown;

export const createInitialSessionOrchestratorState = ({
  phase = SESSION_PHASES.anonymous,
  blockingReason = null,
  targetPath = DEFAULT_SESSION_TARGET_PATH,
  requestId = 0,
  errorCode = "",
  recoveryContext = null,
} = {}) => ({
  phase: isKnownSessionPhase(phase) ? phase : SESSION_PHASES.anonymous,
  blockingReason: normalizeBlockingReason(blockingReason),
  targetPath: normalizeSessionTargetPath(targetPath),
  requestId: normalizeRequestId(requestId),
  errorCode: typeof errorCode === "string" ? errorCode.trim() : "",
  recoveryContext:
    typeof recoveryContext === "string" && recoveryContext.trim()
      ? recoveryContext.trim()
      : null,
});

export const clearSessionBlockingState = (state) => ({
  ...state,
  blockingReason: null,
  errorCode: "",
  recoveryContext: null,
});
